import axios from 'axios';

// Detectar si estamos en producción o desarrollo
const isProduction = window.location.hostname !== 'localhost';

// URL del API según el entorno
const API_URL = isProduction 
  ? 'https://inventory-backend-u401.onrender.com/api'  // Producción
  : 'http://localhost:5000/api';                       // Desarrollo

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;